import { Component,OnInit } from '@angular/core';
import { AuthService } from 'app/auth/auth.service';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { Router } from '@angular/router';
import {TranslateService} from '@ngx-translate/core';



declare const $: any;
declare interface RouteInfo {
    path: string;
    title: string;
    icon: string;
    class: string;
}
export const ROUTES: RouteInfo[] = [
  { path: 'dashboard', title: 'Home',  icon: 'home', class: '' },
  { path: 'Registration', title: 'Registration',  icon:'person_add', class: '' },  
  { path: 'Billing/AdvanceReceipt', title: 'Advance Reports',  icon:'flag', class: '' },  
  { path: 'Billing', title: 'Billing',  icon:'assignment', class: '' },
  { path: 'Receipts', title: 'Advance Receipts',  icon:'description', class: '' },
  { path: 'OpdVisit', title: 'OPD Visit',  icon:'account_circle', class: '' },
  { path: 'Appointments', title: 'Appointment',  icon:'call', class: '' },
  { path: 'ipd', title: 'New Admission',  icon:'medication', class: '' },
  { path: 'ipd/dashboard', title: 'IPD Dashboard',  icon:'dashboard', class: '' },
  // { path: '/Apoinment', title: 'Apoinments',  icon:'call', class: '' },
];

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
 })
export class SidebarComponent implements OnInit {
  menuItems: any[];
  today = this.authService.getServerDate;
  defaultuser: number;
  constructor(public authService:AuthService, public dashboardService: DashboardService,
    public router: Router, public translate: TranslateService,) { }

  ngOnInit() {

  

    if (this.authService.selectedrole == 1){
       this.authService.Loggeduser.usertypeid = 1;
    }
    else if (this.authService.selectedrole == 6){
      this.authService.Loggeduser.usertypeid = 6;
   }
   else if (this.authService.selectedrole == 9){
    this.authService.Loggeduser.usertypeid = 9;
 }
 else if (this.authService.selectedrole == 2){
  this.authService.Loggeduser.usertypeid = 2;
}
else if (this.authService.selectedrole == 3){
  this.authService.Loggeduser.usertypeid = 3;
}
else if (this.authService.selectedrole == 4){
  this.authService.Loggeduser.usertypeid = 4;
}
else if (this.authService.selectedrole == 5){
  this.authService.Loggeduser.usertypeid = 5;
}
else if (this.authService.selectedrole == 7){
  this.authService.Loggeduser.usertypeid = 7;
}
else if (this.authService.selectedrole == 8){
  this.authService.Loggeduser.usertypeid = 8;
}

 
   
 

   console.log("usertype id on sidebar " + this.authService.Loggeduser.usertypeid);
    this.menuItems = ROUTES.filter(menuItem => menuItem);
   
    
  }

  filterrole(roletype: string){

    this.authService.selectedrole = null;
 this.authService.Loggeduser.role = roletype;
 this.router.navigateByUrl('/', {skipLocationChange: true}).then(() =>
 this.router.navigate(['/layout/dashboard'], { replaceUrl: true }));

  }

  filterroleid(){
       
    switch (this.authService.Loggeduser.usertypeid) {
      
      //if usertypeid  is 2 (H & E)
      case (2): {
     
        this.authService.Loggeduser.userid = 0;
         break;
       }
       // Clinical Department
       case (3): {
     
        this.authService.Loggeduser.userid = 0;
         break;
       }
       // auto ref
       case (4): {
     
        this.authService.Loggeduser.userid = 0;
         break;
       }
       //opto
       case (5): {
     
        this.authService.Loggeduser.userid = 17;
         break;
       }
       //doctor
       case (6): {
     
        this.authService.Loggeduser.userid = 3;
         break;
       }
       //counslor

           case (7): {
     
            this.authService.Loggeduser.userid = 11;
             break;
           }
          }

    // if (this.authService.Loggeduser.usertypeid == 6) {
    //   this.authService.Loggeduser.userid = 3;
    
      
    //  }
  }
  filterb(newbranchid: number, newbranchname: string){
     this.authService.Loggeduser.branchid = newbranchid;
     this.authService.Loggeduser.branchname = newbranchname;

     
    this.router.navigateByUrl('/', {skipLocationChange: true}).then(() =>
    this.router.navigate(['/layout/dashboard'], { replaceUrl: true }));
  }

  filterbranch(){
 

   // console.log("selected user " + this.authService.Loggeduser.usertypeid);

    this.router.navigateByUrl('/', {skipLocationChange: true}).then(() =>
 this.router.navigate(['/layout/dashboard'], { replaceUrl: true }));
  
    console.log ("branch changed");
  }


  logout(){
    // this.translate.setDefaultLang('ar');
    this.authService.Loggedout(2);
    // this.router.navigate['/login'],
    // this.router.navigate(['/']);
  }

  getfinyearstring(finyearid: number){

    return this.authService.FinYears.find(fy=> fy.pkFinYearId == finyearid).displayFinYear;

  }
  isMobileMenu() {
      if ($(window).width() > 991) {
          return false;
      }
      return true;
  };




}






